import { useState, useEffect } from 'react';
import { getChatMessages } from '../../../sevices/chatSupport';

/**
 * Hook for fetching chat messages for a specific session
 * 
 * @param {string|null} sessionId - The chat session ID
 * @param {boolean} enabled - Whether the query should be enabled
 * @returns {Object} Query result with chat messages
 */
export const useChatMessagesQuery = (sessionId, enabled = true) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    if (!enabled || !sessionId) {
      return;
    }

    const fetchMessages = async () => {
      setIsLoading(true);
      setIsError(false);
      setError(null);
      setIsSuccess(false);

      try {
        const response = await getChatMessages(sessionId);
        if (response.success) {
          setData(response.data);
          setIsSuccess(true);
        } else {
          setIsError(true);
          setError(response.error);
        }
      } catch (err) {
        setIsError(true);
        setError(err.message || 'Failed to fetch messages');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMessages();
  }, [sessionId, enabled]);

  return {
    data,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};
